import { createContext, Dispatch, SetStateAction } from 'react'

/**
 * 操作履歴スタックの初期値
 */
export const initialHistoryStackContext: HistoryStackProps = []

/**
 * 操作履歴スタックのContext
 */
export const HistoryStackContext = createContext<HistoryStackContextProps>([
  initialHistoryStackContext,
  (): void => {
    // 初期値として空の関数を設定
  },
])

/**
 * 型定義：操作履歴スタックContext
 */
export type HistoryStackContextProps = [
  HistoryStackProps,
  Dispatch<SetStateAction<HistoryStackProps>>
]

/**
 * 型定義：操作履歴スタック
 */
export type HistoryStackProps = Array<HistoryProps>

/**
 * 型定義：操作履歴
 */
export type HistoryProps = {
  page: string
  inputs: Array<HistoryInputProps>
  action: string
}

/**
 * 型定義：操作履歴の対象Input
 */
export type HistoryInputProps = {
  name: string
  value: object
}
